var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-footer',{attrs:{"fixed":true,"app":""}},[_c('span',[_vm._v("Ich Lerne Deutsch © 2018 - "+_vm._s(_vm.currentYear))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }